export const accordionGql = /* GraphQL */ `... on landingPageContent2023_accordion_BlockType  {
    typeHandle
    sectionTitle
    sectionDescription
    chip
    colors
    allowMultiple
    enableColumns:columns
    accordions {
        ... on accordions_BlockType {
            accordionDescription
            accordionTitle
            icon
            ctaLinks {
                openInANewTab
                linkUrl
                linkLabel
            }
        }
    }
}`;
